import { render, staticRenderFns } from "./client-roster-sidebar.vue?vue&type=template&id=3ecb85a0"
import script from "./client-roster-sidebar.vue?vue&type=script&lang=js"
export * from "./client-roster-sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports